import { render, staticRenderFns } from "./LegPickerSheetMobile.vue?vue&type=template&id=1867b006"
import script from "./LegPickerSheetMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegPickerSheetMobile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports